// **********************************************************
// Filter Modal
// **********************************************************

attachEvent('.filter-modal .dropdown__placeholder', 'click', (ev) => {
  const parentElem = ev.target.closest('.dropdown');
  const contentEle = parentElem.querySelector('.dropdown__list');
  parentElem.classList.toggle('is-active');
  slideToggle(contentEle, 200, 'block');
});

// Close modal
attachEvent('[data-close-filter-modal]', 'click', (ev) => {
  toggleModal(ev.target, false);
  const parentElem = ev.target.closest('.filter-modal');
  parentElem.classList.add('is-closed');
});

// Open modal
attachEvent('[data-filter-modal-trigger]', 'click', (ev) => {
  ev.preventDefault();
  toggleModal(ev.target, true);
  const parentElem = document.querySelector('.filter-modal.is-closed');
  parentElem?.classList.remove('is-closed');
});
